import { Route, Navigate } from 'react-router-dom'
import Protected from '@/routes/Protected'
import AppShell from '@/components/AppShell/AppShell'
import PATHS, { HOME_THREAD_ROUTE_PATTERN } from '@/routes/paths'
import {
  AppShellRouteFallback,
  AppGenRoute,
  HomeMainLayoutRoute,
  SettingsDeepLinkRoute,
} from '@/routes/appShellRouteElements'

/** @returns {import('react').ReactElement[]} */
export default function appShellRoutes() {
  return [
    <Route
      key="app-shell"
      element={
        <Protected>
          <AppShell />
        </Protected>
      }
    >
      <Route index element={<Navigate to={PATHS.HOME} replace />} />
      <Route path={HOME_THREAD_ROUTE_PATTERN} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.HOME} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.APPGEN} element={<AppGenRoute />} />
      <Route path={PATHS.SETTINGS} element={<SettingsDeepLinkRoute />} />
      <Route path={`${PATHS.SETTINGS}/:sectionId`} element={<SettingsDeepLinkRoute />} />
      <Route path="*" element={<Navigate to={PATHS.HOME} replace />} />
    </Route>,
  ]
}

export { AppShellRouteFallback }
